// ─────────────────────────────────────────────────────────────────────────────
// Aliases Selectors
// ─────────────────────────────────────────────────────────────────────────────
// NgRx selectors for the productAliases store slice.
// ─────────────────────────────────────────────────────────────────────────────

import { createFeatureSelector, createSelector } from '@ngrx/store';
import { ProductAliasesState } from './aliases.reducers';

// ── Feature selector ─────────────────────────────────────────────────────────

export const selectProductAliases = createFeatureSelector<ProductAliasesState>('productAliases');

// ── Basic selectors ──────────────────────────────────────────────────────────

export const selectAliasItems = createSelector(selectProductAliases, (state) => state.aliases);
export const selectAliasMetadata = createSelector(selectProductAliases, (state) => state.metadata);
export const selectAliasLoading = createSelector(selectProductAliases, (state) => state.loading);

